// src/components/Game.js
import React, { useState, useEffect, useCallback } from 'react';
import QuizOptions from './QuizOptions';

// Función para obtener N elementos aleatorios de un array (para opciones incorrectas)
function getRandomElements(arr, n, exclude) {
  const available = arr.filter(item => item.id !== exclude.id);
  const shuffled = [...available].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
}

function Game({ flowers, onFlowerDiscovered, onCorrectAnswer, discoveredFlowers, setCurrentView }) {
  const [currentFlower, setCurrentFlower] = useState(null);
  const [options, setOptions] = useState([]);
  const [message, setMessage] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);

  const setupNewQuestion = useCallback(() => {
    // Filtrar flores que aún no han sido descubiertas si se quiere evitar repetición inmediata
    // o simplemente tomar cualquiera para más rejugabilidad
    const availableFlowers = flowers; // Podría filtrarse aquí

    if (availableFlowers.length === 0) {
      setMessage("¡Has identificado todas las flores disponibles en esta ronda!");
      // Podría redirigir al herbario o menú
      setTimeout(() => setCurrentView('herbarium'), 3000);
      return;
    }

    const randomFlower = availableFlowers[Math.floor(Math.random() * availableFlowers.length)];
    setCurrentFlower(randomFlower);

    const incorrectOptions = getRandomElements(flowers, 3, randomFlower);
    const allOptions = [...incorrectOptions, randomFlower].sort(() => 0.5 - Math.random());

    setOptions(allOptions);
    setMessage('');
    setIsAnswered(false);
  }, [flowers, setCurrentView]); // Removido discoveredFlowers si no se usa para filtrar aquí

  useEffect(() => {
    setupNewQuestion();
  }, [setupNewQuestion]);

  const handleAnswer = (selectedOption) => {
    setIsAnswered(true);

    if (selectedOption.id === currentFlower.id) {
      setMessage(`¡Correcto! Es un/a ${currentFlower.nombreComun}.`);
      onCorrectAnswer(10); // Otorgar 10 puntos
      onFlowerDiscovered(currentFlower); // Esto cambiará la vista a FlowerCard
    } else {
      setMessage(`Incorrecto. La respuesta era ${currentFlower.nombreComun}.`);
      // Podrías mostrar la ficha igualmente para aprender
      setTimeout(() => {
        onFlowerDiscovered(currentFlower); // Muestra la ficha incluso si es incorrecto
      }, 1500); // Espera un poco antes de mostrar la ficha
    }
  };

  if (!currentFlower) {
    return <div>Cargando juego...</div>;
  }

  return (
    <div className="game-container">
      <h2>¿Qué flor es esta?</h2>
      <img
        src={process.env.PUBLIC_URL + currentFlower.imagenUrl}
        alt="Flor a identificar"
        className="flower-image-game"
      />
      {!isAnswered && <QuizOptions options={options} onAnswer={handleAnswer} />}
      {message && <p className="feedback-message">{message}</p>}
      {/* El botón "Siguiente" se maneja por el cambio de vista desde FlowerCard */}
    </div>
  );
}

export default Game;